import React from "react";
import Table from "../../../../../../common/element/Table";
import moment from "moment";

const { Tr, Th, Td, THead, TBody } = Table;

const DataList = ({ data, handleSort, currentFilters }) => {
  const getSortIcon = (field) => {
    return (
      <svg
        className={`transform transition-transform duration-200 ${
          currentFilters.sort === field && currentFilters.order === "asc"
            ? "rotate-180"
            : ""
        }`}
        width="17"
        height="16"
        viewBox="0 0 17 16"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M8.712 3.333v9.334m0 0L13.38 8m-4.667 4.667L4.045 8"
          stroke="#475467"
          strokeWidth="1.333"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    );
  };

  return (
    <React.Fragment>
      <div className="overflow-hidden border rounded-lg border-gray-200 cstm-table">
        <Table>
          <THead>
            <Tr>
              <Th onClick={(e) => handleSort(e, "client_trading_name")} className="cursor-pointer select-none">
                <span className="flex items-center gap-1">
                  Client Name {getSortIcon("client_trading_name")}
                </span>
              </Th>
              <Th onClick={(e) => handleSort(e, "provider_org_id")} className="cursor-pointer select-none">
                <span className="flex items-center gap-1">
                  Provider ID {getSortIcon("provider_org_id")}
                </span>
              </Th>
              <Th onClick={(e) => handleSort(e, "provider_trading_name")} className="cursor-pointer select-none">
                <span className="flex items-center gap-1">
                  Provider Name {getSortIcon("provider_trading_name")}
                </span>
              </Th>
              <Th>
                Provider Status
              </Th>
              <Th>
                State
              </Th>
              <Th onClick={(e) => handleSort(e, "contact_name")} className="cursor-pointer select-none">
                <span className="flex items-center gap-1">
                  Contact Name {getSortIcon("contact_name")}
                </span>
              </Th>
              <Th onClick={(e) => handleSort(e, "document_type_name")} className="cursor-pointer select-none">
                <span className="flex items-center gap-1">
                  Document Type {getSortIcon("document_type_name")}
                </span>
              </Th>
              <Th onClick={(e) => handleSort(e, "document_name")} className="cursor-pointer select-none">
                <span className="flex items-center gap-1">
                  Document Name {getSortIcon("document_name")}
                </span>
              </Th>
              <Th onClick={(e) => handleSort(e, "expiry_date")} className="cursor-pointer select-none">
                <span className="flex items-center gap-1">
                  Expiry Date {getSortIcon("expiry_date")}
                </span>
              </Th>
            </Tr>
          </THead>
          <TBody>
            {data?.DocsReport?.length > 0 ? (
              data.DocsReport.map((item, index) => (
                <Tr key={index}>
                  <Td className="font-medium text-gray-900">{item?.client_trading_name || "-"}</Td>
                  <Td>{item?.provider_org_id || "-"}</Td>
                  <Td>{item?.provider_trading_name || "-"}</Td>
                  <Td>
                    {item?.provider_status ? (
                      <span
                        className={
                          item.provider_status === "Compliant"
                            ? "badge bg-success-50 text-success-700 py-0.5 px-2 rounded-lg font-medium whitespace-nowrap border border-success-200"
                            : item.provider_status === "Registered" || item.provider_status === "Assigned"
                              ? "badge bg-blue-50 text-blue-700 py-0.5 px-2 rounded-lg font-medium whitespace-nowrap border border-blue-200"
                              : "badge bg-error-50 text-error-700 py-0.5 px-2 rounded-lg font-medium whitespace-nowrap border border-error-200"
                        }
                      >
                        {item.provider_status}
                      </span>
                    ) : (
                      "-"
                    )}
                  </Td>
                  <Td>{item?.state_name || "-"}</Td>
                  <Td>{item?.contact_name || "-"}</Td>
                  <Td>{item?.document_type_name || "-"}</Td>
                  <Td className="truncate max-w-xs" title={item?.document_name}>
                    {item?.document_name || "-"}
                  </Td>
                  <Td className="whitespace-nowrap font-medium text-gray-900">
                    {item?.expiry_date ? moment(item.expiry_date).format("DD/MM/YYYY") : "-"}
                  </Td>
                </Tr>
              ))
            ) : (
              <Tr>
                <Td colSpan={9} className="text-center py-8 text-gray-500">
                  No expiring documents found matching your filter criteria.
                </Td>
              </Tr>
            )}
          </TBody>
        </Table>
      </div>
    </React.Fragment>
  );
};

export default DataList;
